"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.usePhoto = exports.ZOOM_INCREMENT = exports.SCROLL_INCREMENT = exports.PhotoProvider = exports.DEFAULT_ZOOM_SCALE = void 0;

var _react = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const ZOOM_INCREMENT = 0.15;
exports.ZOOM_INCREMENT = ZOOM_INCREMENT;
const SCROLL_INCREMENT = 0.05;
exports.SCROLL_INCREMENT = SCROLL_INCREMENT;
const DEFAULT_ZOOM_SCALE = 0.2;
exports.DEFAULT_ZOOM_SCALE = DEFAULT_ZOOM_SCALE;
const DEFAULT_MIN_ZOOM = 0.2;
const PhotoContext = /*#__PURE__*/(0, _react.createContext)({
  state: {
    zoom: DEFAULT_ZOOM_SCALE,
    minZoom: DEFAULT_MIN_ZOOM,
    dimensions: {
      height: null,
      width: null
    }
  },
  handlers: null
});

const PhotoProvider = ({
  children
}) => {
  const [zoom, setZoom] = (0, _react.useState)(DEFAULT_ZOOM_SCALE);
  const [minZoom, setMinZoom] = (0, _react.useState)(DEFAULT_MIN_ZOOM);
  const [dimensions, setDimensions] = (0, _react.useState)({
    height: null,
    width: null
  });
  const handlers = {
    setZoom: zoom => {
      setZoom(Math.max(zoom, minZoom));
    },
    setMinZoom: minZoom => {
      setMinZoom(minZoom);
    },
    setDimensions: dimensions => {
      setDimensions(dimensions);
    },
    resetZoom: () => {
      setZoom(DEFAULT_ZOOM_SCALE);
      setDimensions({
        height: null,
        width: null
      });
    }
  };
  const value = {
    state: {
      minZoom,
      zoom,
      dimensions
    },
    handlers
  };
  return /*#__PURE__*/_react.default.createElement(PhotoContext.Provider, {
    value: value
  }, children);
};

exports.PhotoProvider = PhotoProvider;

const usePhoto = () => {
  const context = (0, _react.useContext)(PhotoContext);

  if (context === undefined) {
    throw new Error("usePhoto must be used within a PhotoProvider");
  }

  return context;
};

exports.usePhoto = usePhoto;